import React from "react"
import classnames from "classnames"
import styles from "./StickySection.less"
import componentParser from "AtomicUtils/componentParser"
import { WINDOW } from "AtomicUtils/environment"
import debounce from 'AtomicUtils/debounce'

class StickySection extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      fixed: false,
    }
  }

  componentDidMount() {
    this._checkOffset()
    WINDOW.addEventListener("scroll", debounce(this._checkOffset, 0), {
      passive: true
    })
  }

  componentWillUnmount() {
    WINDOW.removeEventListener("scroll", debounce(this._checkOffset,0), {
      passive: true
    });
  }

  _checkOffset = () => {
    if (this.stickySectionParent) {
      if (this.stickySectionParent.offsetTop + this.stickySection.offsetHeight/2 < WINDOW.scrollY ) {
        this.stickySectionParent.style.height = `${this.stickySection.offsetHeight}px`
        this.setState({
          fixed: true
        })
      } else {
        this.setState({
          fixed: false
        })
      }
    }
  }

  render() {
    const { components = [], alwaysOnTop = false, children } = this.props
    const { fixed } = this.state
    return (
      <div
        className={classnames({
          [styles.StickySectionParent]: true,
        })}
        ref={c => this.stickySectionParent = c}>
        <div
          ref={c => this.stickySection = c}
          className={classnames({
            [styles.StickySection]: true,
            [styles.StickySectionTop]: alwaysOnTop,
            [styles.StickySectionFixed]: fixed
          })}>
          {componentParser(components,this.props) || children}
        </div>
      </div>
    )
  }
}


export default StickySection



// WEBPACK FOOTER //
// ./src/AtomicComponents/StickySection/StickySection.jsx